import seoData from "./seoData";

const { SITE, BASE, SEO_MAP, COLLECTION_SEO } = seoData;
export const OG_IMAGE = seoData.OG_IMAGE;
export const DEFAULT_DESC = seoData.DEFAULT_DESC;
export { SEO_MAP };

export function resolveSeo(pathname, search) {
  const params = new URLSearchParams(search || "");
  const collection = params.get("collection");
  if (pathname === "/shop" && collection && COLLECTION_SEO[collection]) {
    return COLLECTION_SEO[collection];
  }
  return SEO_MAP[pathname] || null;
}

export function setDocumentSeo(title, description, image) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} · Curated Care Boxes & Hope Cards`;
  document.title = fullTitle;
  const desc = description || DEFAULT_DESC;
  const img = image || OG_IMAGE;
  const set = (selector, attr, value) => {
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement("meta");
      const [k, v] = selector.replace("meta[", "").replace("]", "").split("=");
      el.setAttribute(k, v.replace(/["']/g, ""));
      document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
  };
  set('meta[name="description"]', "content", desc);
  set('meta[property="og:type"]', "content", "website");
  set('meta[property="og:site_name"]', "content", SITE);
  set('meta[property="og:title"]', "content", fullTitle);
  set('meta[property="og:description"]', "content", desc);
  set('meta[property="og:image"]', "content", img);
  set('meta[property="og:url"]', "content", BASE + window.location.pathname);
  set('meta[name="twitter:card"]', "content", "summary_large_image");
  set('meta[name="twitter:title"]', "content", fullTitle);
  set('meta[name="twitter:description"]', "content", desc);
  set('meta[name="twitter:image"]', "content", img);
  // canonical
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
  link.setAttribute("href", BASE + window.location.pathname);
}
